/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Newspage_Meta_TitleInputs */

const en_fw_newspage_meta_title = /** @type {(inputs: Fw_Newspage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding Anime News & Updates`)
};

const zh_fw_newspage_meta_title = /** @type {(inputs: Fw_Newspage_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画新闻与最新动态`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding Anime News & Updates" |
*
* @param {Fw_Newspage_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_newspage_meta_title = /** @type {((inputs?: Fw_Newspage_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Newspage_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_newspage_meta_title(inputs)
	return zh_fw_newspage_meta_title(inputs)
});
export { fw_newspage_meta_title as "fw.newspage.meta_title" }